<template>
  <p v-if="emptyType === 'basic'" class="search-file-empty">해당 데이터가 없습니다.</p>
  <p v-else-if="emptyType === 'recruit'" class="search-file-empty empty-comm">현재 진행중인 채용 공고가 없습니다.</p>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    emptyType: {
      type: String,
      required: true
    }
  },
  created () {
    // console.log('>>>>> type', this.emptyType);
  }
}
</script>

<style lang="css" scoped>
  .search-file-empty {margin-top:84px; padding-top: 86px; font-size: 22px; text-align: center; color: #a5a5a5; background: url("../../assets/images/customer/icon-error-74.png") 50% 0 no-repeat; vertical-align: middle;}
  .empty-comm {margin-bottom:84px;}
</style>
